import { useState } from 'react';
import { useAuth } from '../Auth/store';
import { Button as CustomButton } from "../Buttons/button";
import IcoExpand from '../../images/arrow-expand.svg';
import IcoCollapse from '../../images/ico_collapse.svg';
import IcoMap from '../../images/ico_map.svg';
import IcoWarning from '../../images/ico_warning.svg';
import IcoReport from '../../images/ico_reports.svg';
import References from '../../helpers/Reference';

export const LeftMenu = ({isShowMain}) => {

    const DELTA_TOP_WITH_MAIN_MENU_BUTTON = isShowMain ? 1 : 0
    const EXT_CLASS_WITH_MAIN_MENU_BUTTON = isShowMain ? 'item-with-main-menu' : ''

    const [ isExpand, setIsExpand ] = useState( false );
    const {permission} = useAuth()

    const onShowHideBtnClick = () => {
        setIsExpand(!isExpand);
    }

    if (!permission?.permissions?.can_view_event_data) 
        return <></>

    return <>
        <CustomButton 
            id="left_menu_btn_expand"
            position={{left: 10, top: 10}}
            type="circle"
            icon={IcoExpand}
            tooltip={{
                title: References.dictionary.tooltips.button_open_menu
            }}
            size="md"
            handleClick={onShowHideBtnClick}
        />
        <div id="left-menu" className={isExpand ? "left-menu-expand" : "left-menu-collapse"}>
            <CustomButton
                id="left_menu_btn_collapse"
                position={{left: 15, top: 10}}
                type="circle"
                icon={IcoCollapse}
                tooltip={{
                    title: References.dictionary.tooltips.button_hide_menu
                }}
    
                size="md"
                handleClick={onShowHideBtnClick}        
            />
            <div className="lefmtnuTitle item1">Свернуть</div>            

            <CustomButton
                id="left_menu_btn_event"
                position={{left: 15, top: 100 + DELTA_TOP_WITH_MAIN_MENU_BUTTON * 90}}
                type="circle"
                icon={IcoWarning}
                tooltip={{
                    title: References.dictionary.tooltips.button_go_event
                }}

                size="md"
                children={<>
                    <a href="/event"></a>
                </>}
            />
            <div className={`lefmtnuTitle item2 ${EXT_CLASS_WITH_MAIN_MENU_BUTTON}`}>События</div>


            {permission?.permissions?.can_view_data_archive &&
            <>
            <CustomButton
                id="left_menu_btn_report"
                position={{left: 15, top: 190 + DELTA_TOP_WITH_MAIN_MENU_BUTTON * 90}}
                type="circle"
                icon={IcoReport}
                tooltip={{
                    title: References.dictionary.tooltips.button_go_report
                }}

                size="md"
                children={<>
                    <a href="/reports"></a>
                </>}
            />
            <div className={`lefmtnuTitle item3 ${EXT_CLASS_WITH_MAIN_MENU_BUTTON}`}>Отчеты</div>            
            </>
            }

            {isShowMain && 
            <>
            <CustomButton
                id="left_menu_btn_map"
                position={{left: 15, top: 100}}
                type="circle"
                icon={IcoMap}
                tooltip={{
                    title: References.dictionary.tooltips.button_go_map
                }}

                size="md"
                children={<>
                    <a href="/"></a>
                </>}
            />
            <div className="lefmtnuTitle item-map">Карта</div>            
            </>

            }
        </div>
    </>;
}